var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"パス_90","data-name":"パス 90","d":"M25.707,10.417a1,1,0,0,0-1.416,0l-6,6a1,1,0,0,0,0,1.416l6,6a1,1,0,1,0,1.416-1.416l-5.293-5.292,5.293-5.292a1,1,0,0,0,0-1.416Z","transform":"translate(-17.998 -10.123)","fillRule":"evenodd","key":0}),React.createElement("path",{"id":"パス_91","data-name":"パス 91","d":"M24,17.875a1,1,0,0,0-1-1H10a1,1,0,1,0,0,2H23A1,1,0,0,0,24,17.875Z","transform":"translate(-7.998 -10.874)","fillRule":"evenodd","key":1})]);
}

ArrowLeft.defaultProps = {"id":"arrow-right-short","width":"1em","height":"1em","viewBox":"0 0 16 14.001","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
